// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import { ArrowLeft, Phone } from "lucide-react";
// import Card from "src/components/Card";
// import { useAppDispatch, useAppSelector } from "src/stores";
// import {
//   fetchCallLogsDetails,
//   selectCallLogsDetails,
// } from "src/stores/calllogs";
// import Lucide from "src/base-components/Lucide";
// import Pagination from "src/base-components/Pagination";
// import LoadingIcon from "src/base-components/LoadingIcon";
// import { getTableColorFromStatus } from "src/helpers";
// import { userTimeZone } from "src/components/CallsLogsModal/constants";
// import { getCallActivityLogs } from "src/services/callActivityLog.services";

// // interface CallDetails {
// //   id: string;
// //   customerName: string;
// //   customerPhone: string;
// //   customerEmail: string;
// //   status: "Completed" | "Answered" | "Missed" | "Declined";
// //   outcome: string;
// //   dateTime: string;
// //   duration: string;
// //   agent: string;
// //   queryId: string;
// // }

// // interface CustomerCallHistory {
// //   id: string;
// //   type: "Support" | "Sales" | "Others";
// //   dateTime: string;
// //   duration: string;
// //   outcome: string;
// //   agent: string;
// //   icon: string | JSX.Element;
// // }

// // interface QueryDetails {
// //   queryId: string;
// //   status: "In-progress" | "Payment in Progress";
// //   testerTest: string;
// //   customerId: string;
// //   noOfPax: number;
// //   source: string;
// //   location: string;
// //   dated: string;
// //   lastUpdated: string;
// //   createdBy: string;
// //   assignedTo: string;
// // }

// const CallDetailsPage = () => {
//   const [currentPage, setCurrentPage] = useState<number>(1);
//   const [activityLogs, setActivityLogs] = useState<any[]>([]);

//   console.log("====================================");
//   console.log(activityLogs, "activity logs in details page");
//   console.log("====================================");
//   const [activityPagination, setActivityPagination] = useState<any>(null);
//   const [loadingLogs, setLoadingLogs] = useState(false);
//   const { id } = useParams<{ id: string }>();
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();

//   const location = useLocation();
//   const { session_id } = location.state as { session_id?: string | null };

//   // Fetch activity logs from the service
//   const fetchActivityLogs = async () => {
//     if (!session_id) return;
//     setLoadingLogs(true);
//     try {
//       const response = await getCallActivityLogs(session_id, currentPage);

//       if (response?.result?.records) {
//         setActivityLogs(response.result.records);
//         setActivityPagination(response.result.pagination);
//       }
//     } catch (error) {
//       console.error("Error fetching activity logs:", error);
//     } finally {
//       setLoadingLogs(false);
//     }
//   };

//   useEffect(() => {
//     if (session_id) {
//       dispatch(
//         fetchCallLogsDetails({ sessionId: session_id, page: currentPage }),
//       );
//       fetchActivityLogs();
//     }
//   }, [session_id, currentPage]);
//   const { loading, data } = useAppSelector(selectCallLogsDetails);

//   console.log(data, "call details data");
//   const formatDuration = (seconds) => {
//     if (!seconds || isNaN(seconds)) return "--";

//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;

//     return `${mins}:${secs.toString().padStart(2, "0")}`;
//   };
//   const getStatusColor = (status: string) => {
//     switch (status) {
//       case "Completed":
//         return "bg-green-100 text-green-800 border-green-200";
//       case "Answered":
//         return "bg-blue-100 text-blue-800 border-blue-200";
//       case "Missed":
//         return "bg-red-100 text-red-800 border-red-200";
//       case "Declined":
//         return "bg-yellow-100 text-yellow-800 border-yellow-200";
//       default:
//         return "bg-gray-100 text-gray-800 border-gray-200";
//     }
//   };

//   const getQueryStatusColor = (status: string) => {
//     switch (status) {
//       case "In-progress":
//         return "bg-blue-100 text-blue-800";
//       case "Payment in Progress":
//         return "bg-green-100 text-green-800";
//       default:
//         return "bg-gray-100 text-gray-800";
//     }
//   };

//   const getCallTypeColor = (type: string) => {
//     switch (type) {
//       case "Support":
//         return "text-blue-600";
//       case "Sales":
//         return "text-green-600";
//       case "Others":
//         return "text-purple-600";
//       default:
//         return "text-gray-600";
//     }
//   };

//   const formattedTime =
//     data?.call?.event_time && userTimeZone(data?.call?.event_time);

//   const formattedCreatedDate =
//     data?.call?.query_info?.created_at &&
//     userTimeZone(data?.call?.query_info?.created_at);

//   const formattedUpdatedDate =
//     data?.call?.query_info?.updated_at &&
//     userTimeZone(data?.call?.query_info?.updated_at);

//   const formatLogsDatetime = (date: any) => {
//     return userTimeZone(date);
//   };
//   // const formattedTime = data?.call?.event_time
//   //   ? moment(data?.call?.event_time, "YYYY-MM-DD HH:mm:ss").format(
//   //       "DD/MM/YYYY, HH:mm:ss"
//   //     )
//   //   : ;
//   // const formattedCreatedDate = data?.call?.query_info?.created_at
//   //   ? moment(data?.call?.query_info?.created_at, "YYYY-MM-DD HH:mm:ss").format(
//   //       "DD-MM-YYYY"
//   //     )
//   //   : "--";
//   // const formattedUpdatedDate = data?.call?.query_info?.updated_at
//   //   ? moment(data?.call?.query_info?.updated_at, "YYYY-MM-DD HH:mm:ss").format(
//   //       "DD-MM-YYYY"
//   //     )
//   //   : "--";
//   // const formatLogsDatetime = (date: any) => {
//   //   return moment(date, "YYYY-MM-DD HH:mm:ss").format("MMM DD, hh:mm A");
//   // };

//   const handlePageClick = (page: number) => {
//     if (page !== currentPage) {
//       setCurrentPage(page);
//     }
//   };

//   const handleNextPage = () => {
//     if (currentPage < (data?.pagination?.last_page || 1)) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const handleFirstPage = () => {
//     setCurrentPage(1);
//   };

//   const handleLastPage = () => {
//     setCurrentPage(data?.pagination?.last_page || 1);
//   };

//   const noOfPax =
//     (data?.call?.query_info?.no_of_adults ?? 0) +
//     (data?.call?.query_info?.no_of_children ?? 0) +
//     (data?.call?.query_info?.no_of_infants ?? 0);

//   const handleRowClick = (logId: number, sessionId: string) => {
//     navigate(`/call-logs/${logId}`, { state: { session_id: sessionId } });
//   };

//   return (
//     <div className="min-h-screen p-6">
//       {/* Header */}
//       <div className="mb-6">
//         <div className="flex items-center space-x-4 mb-4">
//           <button
//             onClick={() => navigate(-1)}
//             className="flex items-center space-x-2 px-3 py-2 bg-[#233580] text-white rounded-lg hover:bg-[#233590] transition-colors"
//           >
//             <ArrowLeft className="w-4 h-4" />
//             <span>Back</span>
//           </button>
//           {/* <div> */}
//           <h1 className=" font-medium text-lg text-[#475569]">Call Details</h1>
//           {/* <Lucide icon="ArrowRight" className="w-7 h-7" />
//           <p className="font-medium  text-lg text-[#475569]">
//             Detailed information and logs for call
//           </p> */}
//           {/* </div> */}
//           {/* <div className="ml-auto"> */}
//           {/* <span className="bg-[#F1F5F9] border border-[#E2E8F0] text-[#64748B] px-3 py-1 rounded text-sm">
//             CALL 001
//           </span> */}
//           {/* </div> */}
//         </div>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//         {/* Left Column - Call Details */}
//         <div className="lg:col-span-1 space-y-6">
//           {/* Call Details Card */}
//           <Card className="p-6">
//             <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wide mb-4">
//               CALL DETAILS
//             </h3>
//             {loading ? (
//               <div className="flex justify-center items-center py-8">
//                 <LoadingIcon color="#64748b" icon="oval" className="w-8 h-8" />
//               </div>
//             ) : (
//               <>
//                 <div className="flex items-start space-x-4 mb-6">
//                   <div className="p-3 bg-blue-50 rounded-full">
//                     <Phone className="w-6 h-6 text-blue-600" />
//                   </div>
//                   <div className="flex-1">
//                     <div className="flex items-center space-x-2 mb-1">
//                       <h4 className="text-lg font-semibold text-gray-900">
//                         {data?.customer_info?.fullname}
//                       </h4>
//                       <span
//                         className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
//                           data?.call?.query_info?.status_text,
//                         )}`}
//                       >
//                         {data?.call?.query_info?.status_text}
//                       </span>
//                     </div>
//                     <p className="text-gray-600">
//                       {data?.customer_info?.phone}
//                     </p>
//                     {data?.customer_info && (
//                       <p className="text-gray-600">
//                         {data?.customer_info?.email}
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 <div className="space-y-4">
//                   {/* <div className="flex justify-between">
//                     <span className="text-gray-600">Outcome</span>
//                     <span className="font-medium text-gray-900">
//                       {data?.call?.call_outcome ?? "--"}
//                     </span>
//                   </div> */}
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Date & Time</span>
//                     <span className="font-medium text-gray-900">
//                       {formattedTime ? formattedTime.logDateTime : "--"}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Duration (seconds)</span>
//                     <span className="font-medium text-gray-900">
//                       {data?.call?.duration_seconds ?? "--"}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Call Direction</span>
//                     <span className="font-medium text-gray-900">
//                       {data?.call?.direction ?? "--"}
//                     </span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600">User</span>
//                     <span className="font-medium text-gray-900">
//                       {data?.call?.agent_name || "--"}
//                     </span>
//                   </div>

//                   <div className="flex justify-between">
//                     <span className="text-gray-600">Remarks</span>
//                     <span className="font-medium text-gray-900 text-wrap max-w-[150px] text-left">
//                       {data?.call?.remarks || "--"}
//                     </span>
//                   </div>
//                   {data?.call?.query_info?.id && (
//                     <div className="flex justify-between items-center">
//                       <span className="text-gray-600">
//                         This call is linked to query
//                       </span>
//                       <span
//                         className="text-blue-600 font-medium cursor-pointer border rounded-xl px-2 py-1"
//                         onClick={() => {
//                           navigate(
//                             "/query-detail/" + data?.call?.query_info?.id,
//                           );
//                         }}
//                       >
//                         {data?.call?.query_info?.query_no}
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               </>
//             )}
//           </Card>

//           {/* Query Details Card */}
//           {data?.call?.query_id && (
//             <Card className="p-6">
//               {loading ? (
//                 <div className="flex justify-center items-center py-8">
//                   <LoadingIcon
//                     color="#64748b"
//                     icon="oval"
//                     className="w-8 h-8"
//                   />
//                 </div>
//               ) : (
//                 <>
//                   <div className="flex items-center justify-between mb-4">
//                     {data?.call?.query_info?.id && (
//                       <div className="flex  items-center">
//                         <div
//                           className={`h-4 w-1 mr-1 ${
//                             data?.call?.query_info?.stage == 4
//                               ? getTableColorFromStatus[16]
//                               : data?.call?.query_info?.stage == 2
//                                 ? data?.call?.query_info?.assigned_by &&
//                                   !data?.call?.query_info?.assigned_to
//                                   ? getTableColorFromStatus[19]
//                                   : getTableColorFromStatus[18]
//                                 : data?.call?.query_info?.stage == 5
//                                   ? getTableColorFromStatus[20]
//                                   : getTableColorFromStatus[
//                                       data?.call?.query_info.status
//                                     ]
//                           }`}
//                         />
//                         <h3 className="text-lg font-semibold text-gray-900">
//                           {data?.call?.query_info?.query_no}
//                         </h3>
//                       </div>
//                     )}
//                     <div className="flex space-x-2">
//                       <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
//                         {data?.call?.query_info?.status_text}
//                       </span>
//                       <span
//                         className={`px-2 py-1 rounded text-xs ${getQueryStatusColor(
//                           data?.call?.query_info?.payment_status,
//                         )}`}
//                       >
//                         {data?.call?.query_info?.payment_status}
//                       </span>
//                     </div>
//                   </div>

//                   <div className="space-y-3">
//                     <div>
//                       <p className="text-gray-900 font-medium">
//                         {data?.customer_info?.fullname}
//                       </p>
//                       <div className="flex justify-between items-center">
//                         <p className="text-xs text-gray-600">
//                           Customer ID: {data?.customer_info?.customer_id}
//                         </p>
//                         <p className="text-sm text-gray-600">
//                           No. of PAX: {noOfPax}
//                         </p>
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-2 gap-4 text-sm border-t-[4px] border-dotted pt-2">
//                       <div>
//                         <p className="text-[#3C7EA1]">Source:</p>
//                         <div className="flex items-center space-x-1">
//                           <Phone className="w-4 h-4 text-gray-400" />
//                           <span className="text-gray-900">
//                             {data?.call?.query_info?.source ?? "--"}
//                           </span>
//                         </div>
//                       </div>
//                       <div className="justify-self-end">
//                         <p className=" text-[#3C7EA1] ">Location:</p>
//                         <p className="text-gray-900 justify-self-end">
//                           {data?.call?.query_info?.location?.name ?? "--"}
//                         </p>
//                       </div>
//                       <div>
//                         <p className="text-[#3C7EA1]">Dated:</p>
//                         <p className="text-gray-900">
//                           {formattedCreatedDate
//                             ? formattedCreatedDate.createdDate
//                             : "--"}
//                         </p>
//                       </div>
//                       <div className="justify-self-end">
//                         <p className="text-[#3C7EA1] ">Last Updated On:</p>
//                         <p className="text-gray-900 justify-self-end">
//                           {formattedUpdatedDate
//                             ? formattedUpdatedDate.updatedDate
//                             : "--"}
//                         </p>
//                       </div>
//                       <div>
//                         <p className="text-[#3C7EA1]">Created By:</p>
//                         <p className="text-gray-900">
//                           {data?.call?.query_info?.sourced_by_user.name ??
//                             "N/A"}{" "}
//                           {data?.call?.query_info?.sourced_by_user.last_name ??
//                             "N/A"}
//                         </p>
//                       </div>
//                       <div className="justify-self-end">
//                         <p className="text-[#3C7EA1] ">Assigned To:</p>
//                         <p className="text-gray-900 justify-self-end">
//                           {data?.call?.query_info?.assigned_to ?? "N/A"}
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </>
//               )}
//             </Card>
//           )}
//         </div>

//         {/* Right Column - Customer Call History */}
//         {/* <div className="lg:col-span-2">
//           <Card className="p-6">
//             <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wide mb-6">
//               CUSTOMER CALL HISTORY
//             </h3>

//             <div className="overflow-x-auto">
//               <table className="w-full">
//                 <thead>
//                   <tr className="border-b border-gray-200">
//                     <th className="text-left py-3 px-4 text-sm font-medium text-gray-600">
//                       Call Direction
//                     </th>
//                     <th className="text-left py-3 px-4 text-sm font-medium text-gray-600">
//                       Date & Time
//                     </th>
//                     <th className="text-left py-3 px-4 text-sm font-medium text-gray-600">
//                       Duration (mm:ss)
//                     </th>

//                     <th className="text-left py-3 px-4 text-sm font-medium text-gray-600">
//                       User
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y divide-gray-200">
//                   {loading ? (
//                     <tr>
//                       <td colSpan={100}>
//                         <div className="flex justify-center items-center py-8">
//                           <LoadingIcon
//                             color="#64748b"
//                             icon="oval"
//                             className="w-8 h-8"
//                           />
//                         </div>
//                       </td>
//                     </tr>
//                   ) : (
//                     data?.logs?.map((call: any) => (
//                       <tr key={call.id} className="hover:bg-gray-50">
//                         <td className="py-3 px-4">
//                           <div className="flex items-center  space-x-2">
//                             <Lucide
//                               icon={
//                                 call?.direction === "Outbound"
//                                   ? "PhoneOutgoing"
//                                   : "PhoneIncoming"
//                               }
//                               color={`${
//                                 call?.direction === "Outbound"
//                                   ? "#00C950"
//                                   : "#2B7FFF"
//                               }`}
//                             />
//                             <p className="font-medium text-gray-900">
//                               {call.direction || "--"}
//                             </p>
//                           </div>
//                         </td>
//                         <td className="py-3 px-4 text-gray-900">
//                           {formatLogsDatetime(call.event_time)?.dateTime ||
//                             "--"}
//                         </td>
//                         <td className="py-3 px-4 text-gray-900">
//                           {formatDuration(call?.duration_seconds)}
//                         </td>

//                         <td className="py-3 px-4 text-gray-900">
//                           {call?.agent_name}
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             <Pagination
//               className="flex-1 w-full mr-auto sm:w-auto"
//               totalItems={data?.pagination?.total_records || 0} // total items
//               rowsPerPage={data?.pagination?.per_page || 10} // items per page
//               currentPage={currentPage}
//               onPageClick={handlePageClick}
//               onNextClick={handleNextPage}
//               onPrevClick={handlePrevPage}
//               onFirstClick={handleFirstPage}
//               onLastClick={handleLastPage}
//               showColors={false}
//             />
//           </Card>
//         </div> */}

//         <div className="lg:col-span-2">
//           <Card className="p-6">
//             <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wide mb-6">
//               USER CALL ACTIVITY
//             </h3>

//             {loadingLogs ? (
//               <div className="flex justify-center items-center py-12">
//                 <LoadingIcon color="#64748b" icon="oval" className="w-8 h-8" />
//               </div>
//             ) : (
//               <>
//                 <div className="space-y-0 mb-6">
//                   {/* Header Row */}
//                   <div className="grid grid-cols-4 gap-4 pb-4 mb-4 border-b border-gray-200">
//                     <div className="text-sm font-medium text-gray-600">
//                       Date
//                     </div>
//                     <div className="col-span-3 text-sm font-medium text-gray-600">
//                       Details
//                     </div>
//                   </div>

//                   {/* Log Entries */}
//                   {activityLogs?.length > 0 ? (
//                     activityLogs.map((log: any, index: number) => {
//                       const userInfo = log.userInfo
//                         ? JSON.parse(log.userInfo)
//                         : {};
//                       return (
//                         <div
//                           // key={log.id || index}
//                           // onClick={() => handleRowClick(log.id, log.session_id)}
//                           className="grid grid-cols-4 gap-4 py-4 border-b border-gray-100  transition-colors "
//                         >
//                           {/* Date Column */}
//                           <div className="flex items-start">
//                             <Lucide
//                               icon="Calendar"
//                               className="w-5 h-5 text-gray-400 mr-2 mt-0.5 flex-shrink-0"
//                             />
//                             <span className="text-sm text-gray-700 font-medium">
//                               {log.created_at
//                                 ? new Date(log.created_at).toLocaleDateString(
//                                     "en-CA",
//                                   )
//                                 : "--"}
//                             </span>
//                           </div>

//                           {/* Details Column */}
//                           <div className="col-span-3">
//                             <div className="flex items-center gap-2 mb-1">
//                               <p className="text-sm text-gray-900 font-medium">
//                                 {log.log_text || "--"}
//                               </p>
//                             </div>

//                             <div className="flex items-center ">
//                               <div className="text-xs text-gray-500 ml-2">
//                                 ({userInfo?.name || "Unknown"}){" "}
//                                 {log?.created_at
//                                   ? new Date(log.created_at).toLocaleTimeString(
//                                       "en-CA",
//                                       {
//                                         timeZone: "America/Toronto",
//                                         hour: "2-digit",
//                                         minute: "2-digit",
//                                         second: "2-digit",
//                                         hour12: false,
//                                       },
//                                     )
//                                   : ""}
//                               </div>
//                             </div>
//                             {/* <p className="text-xs text-gray-500">
//                               UserTimestamp:{" "}
//                               {log.created_at
//                                 ? new Date(log.created_at).toLocaleTimeString(
//                                     "en-GB",
//                                     {
//                                       hour: "2-digit",
//                                       minute: "2-digit",
//                                       second: "2-digit",
//                                     },
//                                   )
//                                 : "--"}
//                             </p> */}
//                           </div>
//                         </div>
//                       );
//                     })
//                   ) : (
//                     <div className="text-center py-8">
//                       <p className="text-gray-500">No call history available</p>
//                     </div>
//                   )}
//                 </div>

//                 {activityLogs?.length > 0 && activityPagination && (
//                   <div className="mt-6 pt-4 border-t border-gray-200">
//                     <Pagination
//                       className="flex-1 w-full mr-auto sm:w-auto"
//                       totalItems={activityPagination?.total_records || 0}
//                       rowsPerPage={activityPagination?.per_page || 10}
//                       currentPage={currentPage}
//                       onPageClick={handlePageClick}
//                       onNextClick={handleNextPage}
//                       onPrevClick={handlePrevPage}
//                       onFirstClick={handleFirstPage}
//                       onLastClick={handleLastPage}
//                       showColors={false}
//                     />
//                   </div>
//                 )}
//               </>
//             )}
//           </Card>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CallDetailsPage;



import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft, Phone } from "lucide-react";
import Card from "src/components/Card";
import { useAppDispatch, useAppSelector } from "src/stores";
import {
  fetchCallLogsDetails,
  selectCallLogsDetails,
} from "src/stores/calllogs";
import LoadingIcon from "src/base-components/LoadingIcon";
import { getTableColorFromStatus } from "src/helpers";
import { userTimeZone } from "src/components/CallsLogsModal/constants";
import { getCallActivityLogs, getCallTransferLogs } from "src/services/callActivityLog.services";

const CallDetailsPage = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [activityLogs, setActivityLogs] = useState<any[]>([]);
  const [activityLogsLoading, setActivityLogsLoading] = useState<boolean>(false);
  // const [totalDuration, setTotalDuration] = useState<number>(0);
  const [dissconnectUser, setDisconnecUser] = useState<string>("");

  console.log("====================================");
  // console.log(activityLogs, "activity logs in details page");
  console.log("====================================");
  const [activityPagination, setActivityPagination] = useState<any>(null);
  const [loadingLogs, setLoadingLogs] = useState(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const location = useLocation();
  // const { session_id } = location.state as { session_id?: string | null };
  const  session_id  = location.state !== null ? location?.state?.session_id : location.pathname.split("/")[2];

  // Fetch activity logs from the service
  const fetchActivityLogs = async () => {
    if (!session_id) return;
    setLoadingLogs(true);
    setActivityLogsLoading(true);
    try {
      const response = await getCallTransferLogs(session_id);
      console.log("Response for transfer call is ", response);

      if (response?.result?.records) {
        // setTotalDuration(response?.result?.total_call_duration_sec);
        setDisconnecUser(response?.result?.disconnected_by?.to_name)
        setActivityLogs(response.result.records);
        setActivityPagination(response.result.pagination);
      }
    } catch (error) {
      console.error("Error fetching activity logs:", error);
    } finally {
      setLoadingLogs(false);
      setActivityLogsLoading(false);
    }
  };

  useEffect(() => {
    if (session_id) {
      dispatch(
        fetchCallLogsDetails({ sessionId: session_id, page: currentPage }),
      );
      fetchActivityLogs();
    }
  }, [session_id, currentPage]);
  const { loading, data } = useAppSelector(selectCallLogsDetails);
  const transfers = data?.call?.transfers || [];

  const enhancedTransfers = React.useMemo(() => {
    if (!activityLogs.length) return [];

    const customerName = data?.customer_info?.fullname || "Customer";
    const first = activityLogs[0];
    const last = activityLogs[activityLogs.length - 1];

    return [
      // {
      //   id: "start-node",
      //   from_name: customerName,
      //   to_name: first.from_name || first.to_name,
      //   reason: "Incoming Call",
      //   talk_time_seconds: null,
      //   transfer_timestamp: first.transfer_timestamp,
      //   isStart: true,
      // },
      ...activityLogs,
      {
        id: "final-node",
        from_name: dissconnectUser,
        to_name: null,
        reason: "Disconnected",
        talk_time_seconds: null,
        transfer_timestamp: last.transfer_timestamp,
        isFinal: true,
      },
    ];
  }, [activityLogs, data]);

  const formatDuration = (seconds) => {
    if (!seconds || isNaN(seconds)) return "--";

    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };
  const getStatusColor = (status: string) => {
    switch (status) {
      case "Completed":
        return "bg-green-100 text-green-800 border-green-200";
      case "Answered":
        return "bg-blue-100 text-blue-800 border-blue-200";
      case "Missed":
        return "bg-red-100 text-red-800 border-red-200";
      case "Declined":
        return "bg-yellow-100 text-yellow-800 border-yellow-200";
      default:
        return "bg-gray-100 text-gray-800 border-gray-200";
    }
  };

  const getQueryStatusColor = (status: string) => {
    switch (status) {
      case "In-progress":
        return "bg-blue-100 text-blue-800";
      case "Payment in Progress":
        return "bg-green-100 text-green-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const formattedTime =
    data?.call?.event_time && userTimeZone(data?.call?.event_time);

  const formattedCreatedDate =
    data?.call?.query_info?.created_at &&
    userTimeZone(data?.call?.query_info?.created_at);

  const formattedUpdatedDate =
    data?.call?.query_info?.updated_at &&
    userTimeZone(data?.call?.query_info?.updated_at);

  const formatLogsDatetime = (date: any) => {
    return userTimeZone(date);
  };

  const handleNextPage = () => {
    if (currentPage < (data?.pagination?.last_page || 1)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(data?.pagination?.last_page || 1);
  };

  const noOfPax =
    (data?.call?.query_info?.no_of_adults ?? 0) +
    (data?.call?.query_info?.no_of_children ?? 0) +
    (data?.call?.query_info?.no_of_infants ?? 0);

  const handleRowClick = (logId: number, sessionId: string) => {
    navigate(`/call-logs/${logId}`, { state: { session_id: sessionId } });
  };

  function formatToCustomLocalDateTime(isoString: string): string {
    const date = new Date(isoString);
    if (isNaN(date.getTime())) {
      return '';
    }

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
  }

  return (
    <div className="min-h-screen p-6">
      {/* Header */}
      <div className="mb-6">
        <div className="flex items-center space-x-4 mb-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center space-x-2 px-3 py-2 bg-[#233580] text-white rounded-lg hover:bg-[#233590] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back</span>
          </button>
          {/* <div> */}
          <h1 className=" font-medium text-lg text-[#475569]">Call Details</h1>
          {/* <Lucide icon="ArrowRight" className="w-7 h-7" />
          <p className="font-medium  text-lg text-[#475569]">
            Detailed information and logs for call
          </p> */}
          {/* </div> */}
          {/* <div className="ml-auto"> */}
          {/* <span className="bg-[#F1F5F9] border border-[#E2E8F0] text-[#64748B] px-3 py-1 rounded text-sm">
            CALL 001
          </span> */}
          {/* </div> */}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Left Column - Call Details */}
        <div className="lg:col-span-1 space-y-6">
          {/* Call Details Card */}
          <Card className="p-6">
            <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wide mb-4">
              CALL DETAILS
            </h3>
            {loading ? (
              <div className="flex justify-center items-center py-8">
                <LoadingIcon color="#64748b" icon="oval" className="w-8 h-8" />
              </div>
            ) : (
              <>
                <div className="flex items-start space-x-4 mb-6">
                  <div className="p-3 bg-blue-50 rounded-full">
                    <Phone className="w-6 h-6 text-blue-600" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center space-x-2 mb-1">
                      <h4 className="text-lg font-semibold text-gray-900">
                        {data?.customer_info?.fullname}
                      </h4>
                      <span
                        className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                          data?.call?.query_info?.status_text,
                        )}`}
                      >
                        {data?.call?.query_info?.status_text}
                      </span>
                    </div>
                    <p className="text-gray-600">
                      {data?.customer_info?.phone}
                    </p>
                    {data?.customer_info && (
                      <p className="text-gray-600">
                        {data?.customer_info?.email}
                      </p>
                    )}
                  </div>
                </div>

                <div className="space-y-4">
                  {/* <div className="flex justify-between">
                    <span className="text-gray-600">Outcome</span>
                    <span className="font-medium text-gray-900">
                      {data?.call?.call_outcome ?? "--"}
                    </span>
                  </div> */}
                  <div className="flex justify-between">
                    <span className="text-gray-600">Date & Time</span>
                    <span className="font-medium text-gray-900">
                      {formattedTime ? formattedTime.logDateTime : "--"}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Duration (seconds)</span>
                    <span className="font-medium text-gray-900">
                      {/* {totalDuration ?? "--"} */}
                      {data?.call?.duration_seconds ?? "--"}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Call Direction</span>
                    <span className="font-medium text-gray-900">
                      {data?.call?.direction ?? "--"}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">User</span>
                    <span className="font-medium text-gray-900">
                      {/* {dissconnectUser || "--"} */}
                      {data?.call?.agent_name ?? "No User Assigned"}
                    </span>
                  </div>

                  <div className="flex justify-between">
                    <span className="text-gray-600">Remarks</span>
                    <span className="font-medium text-gray-900 text-wrap break-words max-w-[150px] text-left">
                      {data?.call?.remarks || "--"}
                    </span>
                  </div>
                  {data?.call?.query_info?.id && (
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600">
                        This call is linked to query
                      </span>
                      <span
                        className="text-blue-600 font-medium cursor-pointer border rounded-xl px-2 py-1"
                        onClick={() => {
                          navigate(
                            "/query-detail/" + data?.call?.query_info?.id,
                          );
                        }}
                      >
                        {data?.call?.query_info?.query_no}
                      </span>
                    </div>
                  )}
                </div>
              </>
            )}
          </Card>

          {/* Query Details Card */}
          {data?.call?.query_id && (
            <Card className="p-6">
              {loading ? (
                <div className="flex justify-center items-center py-8">
                  <LoadingIcon
                    color="#64748b"
                    icon="oval"
                    className="w-8 h-8"
                  />
                </div>
              ) : (
                <>
                  <div className="flex items-center justify-between mb-4">
                    {data?.call?.query_info?.id && (
                      <div className="flex  items-center">
                        <div
                          className={`h-4 w-1 mr-1 ${data?.call?.query_info?.stage == 4
                            ? getTableColorFromStatus[16]
                            : data?.call?.query_info?.stage == 2
                              ? data?.call?.query_info?.assigned_by &&
                                !data?.call?.query_info?.assigned_to
                                ? getTableColorFromStatus[19]
                                : getTableColorFromStatus[18]
                              : data?.call?.query_info?.stage == 5
                                ? getTableColorFromStatus[20]
                                : getTableColorFromStatus[
                                data?.call?.query_info.status
                                ]
                            }`}
                        />
                        <h3 className="text-lg font-semibold text-gray-900">
                          {data?.call?.query_info?.query_no}
                        </h3>
                      </div>
                    )}
                    <div className="flex space-x-2">
                      <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                        {data?.call?.query_info?.status_text}
                      </span>
                      <span
                        className={`px-2 py-1 rounded text-xs ${getQueryStatusColor(
                          data?.call?.query_info?.payment_status,
                        )}`}
                      >
                        {data?.call?.query_info?.payment_status}
                      </span>
                    </div>
                  </div>

                  <div className="space-y-3">
                    <div>
                      <p className="text-gray-900 font-medium">
                        {data?.customer_info?.fullname}
                      </p>
                      <div className="flex justify-between items-center">
                        <p className="text-xs text-gray-600">
                          Customer ID: {data?.customer_info?.customer_id}
                        </p>
                        <p className="text-sm text-gray-600">
                          No. of PAX: {noOfPax}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4 text-sm border-t-[4px] border-dotted pt-2">
                      <div>
                        <p className="text-[#3C7EA1]">Source:</p>
                        <div className="flex items-center space-x-1">
                          <Phone className="w-4 h-4 text-gray-400" />
                          <span className="text-gray-900">
                            {data?.call?.query_info?.source ?? "--"}
                          </span>
                        </div>
                      </div>
                      <div className="justify-self-end">
                        <p className=" text-[#3C7EA1] ">Location:</p>
                        <p className="text-gray-900 justify-self-end">
                          {data?.call?.query_info?.location?.name ?? "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#3C7EA1]">Dated:</p>
                        <p className="text-gray-900">
                          {formattedCreatedDate
                            ? formattedCreatedDate.createdDate
                            : "--"}
                        </p>
                      </div>
                      <div className="justify-self-end">
                        <p className="text-[#3C7EA1] ">Last Updated On:</p>
                        <p className="text-gray-900 justify-self-end">
                          {formattedUpdatedDate
                            ? formattedUpdatedDate.updatedDate
                            : "--"}
                        </p>
                      </div>
                      <div>
                        <p className="text-[#3C7EA1]">Created By:</p>
                        <p className="text-gray-900">
                          {data?.call?.query_info?.sourced_by_user.name ??
                            "N/A"}{" "}
                          {data?.call?.query_info?.sourced_by_user.last_name ??
                            "N/A"}
                        </p>
                      </div>
                      <div className="justify-self-end">
                        <p className="text-[#3C7EA1] ">Assigned To:</p>
                        <p className="text-gray-900 justify-self-end">
                          {data?.call?.query_info?.assigned_to ?? "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </Card>
          )}
        </div>
        <div className="lg:col-span-2">
          <Card className="p-6">
            <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wide mb-6">
              USER CALL ACTIVITY
            </h3>

            {activityLogsLoading ? (
              <div className="flex justify-center items-center py-12">
                <LoadingIcon color="#64748b" icon="oval" className="w-8 h-8" />
              </div>
            ) : !activityLogs?.length ? (
              <div className="text-center text-gray-500 py-10">
                No transfer activity found
              </div>
            ) : (
              <div className="space-y-2">
                {enhancedTransfers.map((item: any, index: number) => {
                  const isLast = index === enhancedTransfers.length - 1;

                  return (
                    <React.Fragment key={item.id}>

                      {/* CARD */}
                      <div
                        className={`border rounded-lg p-4 transition
                  ${item.isFinal
                            ? "bg-red-50 border-red-200"
                            : index === 0
                              ? "bg-blue-50 border-blue-200"
                              : "bg-gray-50 border-gray-200"
                          }
                `}
                      >

                        {/* Top Row */}
                        {/* <div className="flex justify-between items-center mb-2">
                          <p className="text-sm font-medium text-gray-900">

                            {item.isFinal ? (
                              <span className="text-red-600 font-semibold">
                                {item.from_name} (Call Ended)
                              </span>
                            ) : (
                              <>
                                <span
                                  className={
                                    item.isStart
                                      ? "text-blue-600 font-semibold"
                                      : ""
                                  }
                                >
                                  {item.from_name || "--"}
                                </span>

                                <span className="text-gray-400 mx-1">→</span>

                                <span>{item.to_name || "--"}</span>
                              </>
                            )}
                          </p>

                          {!item.isFinal && (
                            <span className="text-xs text-gray-500">
                              {item?.talk_duration_sec
                                ? `${item.talk_duration_sec.replace(".", ":")} (seconds)`
                                : ""}
                            </span>
                          )}
                        </div> */}

                        {/* Top Row */}
                        <div className="flex justify-between items-center mb-2">
                          <p className="text-sm font-medium text-gray-900 flex items-center flex-wrap gap-1">

                            {item.isFinal ? (
                              <span className="text-red-600 font-semibold">
                                {item.from_name} (Call Ended)
                              </span>
                            ) : (
                              <>
                                {/* FROM */}
                                <span className={index === 0 ? "text-blue-600 font-semibold" : "text-gray-700"}>
                                  {item.from_name || ""}
                                </span>

                                {/* Arrow */}
                                {/* <span className="text-gray-400 text-xs">→</span> */}
                                <span className="text-gray-600 text-xs">
                                  {"➜"}
                                </span>

                                {/* TO + talk duration badge glued together */}
                                <span className="flex items-center gap-1.5">
                                  <span className={index === 0 ? "text-gray-900 font-semibold" : "text-gray-900"}>
                                    {item.to_name || ""}
                                  </span>

                                  {/* Talk time badge — belongs to to_name */}
                                  {item?.reason === "CallConnected" && item?.talk_duration_sec !== "0.00" && <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-medium whitespace-nowrap">
                                    🕐 {item.talk_duration_sec.replace(".", ":")}s
                                  </span>}
                                  {item?.talk_duration_sec && item?.reason !== "CallStarted" && item?.reason !== "CallConnected" && (
                                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-medium whitespace-nowrap">
                                      🕐 {item.talk_duration_sec.replace(".", ":")}s
                                    </span>
                                  )}
                                </span>
                              </>
                            )}
                          </p>
                        </div>

                        {/* Bottom Row */}
                        <div className="flex justify-between items-center text-xs text-gray-600">
                          <span>
                            {item.isFinal
                              ? "Disconnected"
                              : item.reason || "Transfer"}
                          </span>

                          {item?.event_time && <span>
                            {formatToCustomLocalDateTime(item?.event_time) || ""}
                          </span>
                          }
                        </div>
                        {
                          item?.reason === "CallAnswered" && item?.transfer_call !== 0 && 
                          <div className="mt-2 pt-2 border-t border-gray-200 flex items-start gap-1.5 text-xs">
                            <span className="text-gray-600 shrink-0">
                              {item.from_name} →
                            </span>
                            <span className="text-gray-600 shrink-0">Remark:</span>
                            {item.transfer_remark ? (
                              <span className="text-gray-700 font-medium">{item.transfer_remark}</span>
                            ) : (
                              <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-amber-50 border border-amber-200 text-amber-600 font-medium">
                                Pending
                              </span>
                            )}
                            {item?.remark_update_time && <span className="text-gray-600 shrink-0">{`(${item.remark_update_time})`}</span>}
                          </div>
                        }

                        {!item.isFinal && item?.from_name !== "Millwoods Travels Emergency" && item?.reason !== "CallConnected" && item?.reason !== "CallStarted" && item?.reason !== "CallAnswered" && (
                          <div className="mt-2 pt-2 border-t border-gray-200 flex items-start gap-1.5 text-xs">
                            <span className="text-gray-600 shrink-0">
                              {item.from_name} →
                            </span>
                            <span className="text-gray-600 shrink-0">Remark:</span>
                            {item.transfer_remark ? (
                              <span className="text-gray-700 font-medium">{item.transfer_remark}</span>
                            ) : (
                              <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md bg-amber-50 border border-amber-200 text-amber-600 font-medium">
                                Pending
                              </span>
                            )}
                            {item?.remark_update_time && <span className="text-gray-600 shrink-0">{`(${item.remark_update_time})`}</span>}
                          </div>
                        )}
                      </div>

                      {/* ARROW */}
                      {!isLast && (
                        <div className="flex justify-center">
                          <div className="flex items-center justify-center w-7 h-7 rounded-full bg-gray-100 border border-gray-200 text-gray-500 text-sm">
                            ↓
                          </div>
                        </div>
                      )}

                    </React.Fragment>
                  );
                })}
              </div>
            )}
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CallDetailsPage;
